import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { usePromiseTracker } from "react-promise-tracker";
import Loader from 'react-loader-spinner';
//import { Button } from "react-bootstrap";

//import config from 'config';
import 'bootswatch/dist/cosmo/bootstrap.min.css';

/* 
const express = require('express');
const cors = require('cors');

const app = express();
app.use(express.json());

app.use((req, res, next) => {
  //console.log("Acessou o Middleware!");
  res.header("Access-Control-Allow-Origin", "*");
  res.header("Access-Control-Allow-Methods", 'GET,PUT,POST,DELETE');
  app.use(cors());
  next();
});
 */
//const config = require('config');
//console.log(config.get('DEV-ENVIRONMENT'));

/* const dotenv = require('dotenv');
//const dotenvExpand = require('dotenv-expand');
console.log(process.env);
const config = dotenv.config({
  path: process.env.NODE_ENV === "test" ? ".env.production.local" : ".env.test.local"
}); */


//dotenvExpand(config);

console.log(process.env.NODE_ENV);

const LoadingIndicator = props => {
     const { promiseInProgress } = usePromiseTracker();
  
     return (
       promiseInProgress && 
           <div
            style={{
               width: "100%",
               height: "100",
               display: "flex",
               justifyContent: "center",
               alignItems: "center"
             }}
           >
             <Loader type="ThreeDots" color="#00000" height="100" width="100" />
           </div>
    );  
   }

ReactDOM.render(
  
  <React.StrictMode>
    <App />
    <LoadingIndicator/>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
